module.exports = __webpack_public_path__ + "img/2022-13.519b6f0f.jpg";